module.exports = __webpack_public_path__ + "static/media/pynq-visualizer.2209bcd1.gif";